import { render, staticRenderFns } from "./cortecaja.vue?vue&type=template&id=c45b7d40&"
import script from "./cortecaja.vue?vue&type=script&lang=js&"
export * from "./cortecaja.vue?vue&type=script&lang=js&"
import style1 from "./cortecaja.vue?vue&type=style&index=1&id=c45b7d40&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports